<div class="profile-container" (click)="mailTo()">
    <img [src]="photo" class="img-responsive profile-image" alt="">
    <div class="profile-content">
        <div class="profile-name">{{ name }}</div>
        <div class="profile-email">{{ email | lowercase }}</div>
    </div>
</div>